import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getClientId, getDomain } from '@chegg/one-auth-sdk';
export { recordEvents };
export var EventTypes;
(function (EventTypes) {
  EventTypes["mfaRequired"] = "mfa_challenge_required";
  EventTypes["sendEmailStart"] = "mfa_sent_email_request";
  EventTypes["sendEmailEnd"] = "mfa_sent_email_success";
  EventTypes["sendEmailFail"] = "mfa_sent_email_error";
  EventTypes["validateCodeStart"] = "mfa_validate_code_request";
  EventTypes["validateCodeEnd"] = "mfa_validate_code_success";
  EventTypes["validateCodeFail"] = "mfa_validate_code_error";
  EventTypes["mfaInactiveUser"] = "mfa_inactive_user";
  EventTypes["sendRioEventFail"] = "send_rio_event_fail";
  EventTypes["unknownError"] = "unknown_error";
})(EventTypes || (EventTypes = {}));
function recordCustomEvent(_x, _x2) {
  return _recordCustomEvent.apply(this, arguments);
}
function _recordCustomEvent() {
  _recordCustomEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(eventType, eventData) {
    var env, nrAccount, nrKey, url, data, nrEventBody;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          env = process.env.CHEGG_ENV || 'test';
          nrAccount = env === 'prod' ? '501356' : '501278';
          nrKey = env === 'prod' ? 'NRII-Mi0ZOVEe_ofN3PNkKFbYnXl2rhtskKKD' : 'NRII-NKhYYYt2U1KUxYFcGdb4NKCia61dtujg';
          url = "https://insights-collector.newrelic.com/v1/accounts/".concat(nrAccount, "/events");
          data = _objectSpread({
            env: env,
            eventType: 'MfaEvent',
            clientId: getClientId(),
            domain: getDomain(),
            callTimestamp: Date.now(),
            userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : 'unknown',
            url: typeof window !== 'undefined' ? window.location.href : 'unknown'
          }, eventData);
          nrEventBody = JSON.stringify(data);
          return _context.abrupt("return", fetch(url, {
            method: 'POST',
            cache: 'no-cache',
            headers: {
              'Content-Type': 'application/json',
              'X-insert-Key': nrKey
            },
            body: nrEventBody
          }));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _recordCustomEvent.apply(this, arguments);
}
function recordEvents(_x3) {
  return _recordEvents.apply(this, arguments);
}
function _recordEvents() {
  _recordEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(map) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          Object.keys(map).forEach(function (name) {
            recordCustomEvent('OneAuthEvent', _objectSpread({
              EventName: name,
              SourcePage: window.location.href
            }, map[name]));
          });
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _recordEvents.apply(this, arguments);
}